import React from 'react';
import BtnFilter from './btn-filter';

const Filter=({status , changeStatus})=>{

  const elements=status.map((status)=>{
    return (
      <BtnFilter {...status} changeFilter={changeStatus}/>
    );
  });
  return(
    <div className="wrap-btn-group">
        <div className="btn-group todo-btn-group">
          {elements}
        </div>
      </div>
  );
}


export default Filter;
